"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormAmountFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _placeOrderHelper = require("../../../helpers/placeOrderHelper");
var _FormItem = require("../../form/FormItem");
var _NumberInput = require("../../form/NumberInput");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _pegPriceTypeConstants = require("../../../constants/sendOrder/pegPriceTypeConstants");
var _Slider = require("../../common/Slider/Slider");
var _useMoneyFields2 = require("../hooks/useMoneyFields");
var _useValidators2 = require("../../../constants/useValidators");
var _StrategiesSelection = require("./StrategiesSelection/StrategiesSelection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var breakpoints = [0, 25, 50, 75, 100];
var FormAmountFields = exports.FormAmountFields = function FormAmountFields(_ref) {
  var _instrument$Product2S, _instrument$Product2S2;
  var baseClass = _ref.baseClass,
    formName = _ref.formName,
    maxQuantity = _ref.maxQuantity,
    fieldLayout = _ref.fieldLayout,
    _ref$hasCredit = _ref.hasCredit,
    hasCredit = _ref$hasCredit === void 0 ? false : _ref$hasCredit;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var _useValidators = (0, _useValidators2.useValidators)(),
    greaterThanOrEqualToZero = _useValidators.greaterThanOrEqualToZero,
    greaterThanZero = _useValidators.greaterThanZero,
    requiredNumeric = _useValidators.requiredNumeric,
    optionalGreaterThanZero = _useValidators.optionalGreaterThanZero;
  var _useMoneyFields = (0, _useMoneyFields2.useMoneyFields)(formName, maxQuantity, hasCredit),
    formValues = _useMoneyFields.formValues,
    sliderValue = _useMoneyFields.sliderValue,
    onSliderChange = _useMoneyFields.onSliderChange,
    valueDP = _useMoneyFields.valueDP,
    quantityDP = _useMoneyFields.quantityDP,
    instrument = _useMoneyFields.instrument,
    onChange = _useMoneyFields.onChange,
    isBuy = _useMoneyFields.isBuy,
    isDisabled = _useMoneyFields.isDisabled;
  var anchoredField = formValues.anchoredField,
    orderType = formValues.orderType;
  var validateMaxQuantity = (0, _react.useCallback)(function (value) {
    if (hasCredit) {
      return;
    }
    // Skip validation if price is not set or invalid (which makes maxQuantity = 0)
    var price = formValues.limitPrice || formValues.stopPrice;
    if (!price || price <= 0 || maxQuantity <= 0) {
      return;
    }
    var side = formValues.side == 0 ? 'Buy' : 'Sell';
    return value > maxQuantity ? t("".concat(side, " Amount exceeds the Max ").concat(side, " Amount. Please verify and try again.")) : undefined;
  }, [maxQuantity, formValues.side, formValues.limitPrice, formValues.stopPrice, t, hasCredit]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-entry--fields"
  }, (0, _placeOrderHelper.isStopPriceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "stopPrice",
    placeholder: "0",
    className: baseClass,
    label: t('Stop Price'),
    symbol: (_instrument$Product2S = instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol) !== null && _instrument$Product2S !== void 0 ? _instrument$Product2S : '',
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout
  }), (0, _placeOrderHelper.isLimitPriceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "limitPrice",
    placeholder: "0",
    className: baseClass,
    label: t('Limit Price'),
    symbol: (_instrument$Product2S2 = instrument === null || instrument === void 0 ? void 0 : instrument.Product2Symbol) !== null && _instrument$Product2S2 !== void 0 ? _instrument$Product2S2 : '',
    validate: [optionalGreaterThanZero],
    decimalPlaces: valueDP,
    layout: fieldLayout
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.AmountInput,
    name: "quantity",
    placeholder: "0",
    className: baseClass,
    label: isBuy ? t('Buy Amount') : t('Sell Amount'),
    symbol: instrument.Product1Symbol,
    validate: [greaterThanZero, validateMaxQuantity],
    decimalPlaces: quantityDP,
    onFocus: function onFocus() {
      return onChange('anchoredField', 'quantity');
    },
    isAprox: anchoredField === 'value',
    disabled: isDisabled,
    layout: fieldLayout
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.AmountInput,
    name: "value",
    placeholder: "0",
    className: baseClass,
    label: t('Order Total'),
    symbol: instrument.Product2Symbol,
    validate: [greaterThanZero],
    decimalPlaces: valueDP,
    onFocus: function onFocus() {
      return onChange('anchoredField', 'value');
    },
    isAprox: anchoredField === 'quantity',
    disabled: isDisabled,
    layout: fieldLayout
  }), /*#__PURE__*/_react["default"].createElement(_Slider.Slider, {
    disabled: isDisabled || hasCredit,
    onChange: onSliderChange,
    value: sliderValue,
    breakpoints: breakpoints,
    step: "0.01"
  }), (0, _placeOrderHelper.isTimeInForceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_StrategiesSelection.StrategiesSelection, {
    formName: formName,
    timeInForceOptions: [{
      value: '1',
      label: t('Good Til Canceled')
    }, {
      value: '3',
      label: t('Immediate or Cancel')
    }, {
      value: '4',
      label: t('Fill or Kill')
    }]
  }), (0, _placeOrderHelper.isTrailingAmountFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "trailingAmount",
    placeholder: "0",
    decimalPlaces: valueDP,
    label: t('Trailing Amount'),
    className: baseClass,
    symbol: instrument.Product2Symbol,
    validate: [greaterThanZero],
    layout: fieldLayout
  }), (0, _placeOrderHelper.isLimitOffsetFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "limitOffset",
    placeholder: "0",
    decimalPlaces: valueDP,
    label: t('Limit Offset'),
    className: baseClass,
    symbol: instrument.Product2Symbol,
    validate: [greaterThanZero],
    layout: fieldLayout
  }), (0, _placeOrderHelper.isPegPriceFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "pegPriceType",
    label: t('Peg Price'),
    customClass: baseClass,
    classModifiers: 'short',
    options: Object.keys(_pegPriceTypeConstants.pegPriceTypesNames).map(function (key) {
      return {
        value: key,
        label: _pegPriceTypeConstants.pegPriceTypesNames[key]
      };
    })
  }), (0, _placeOrderHelper.isDisplayQuantityFieldInForm)(orderType) && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "displayQuantity",
    placeholder: "0",
    decimalPlaces: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.QuantityIncrement),
    label: t('Display Quantity'),
    customClass: baseClass,
    labelInInput: instrument.Product1Symbol,
    validate: [requiredNumeric, greaterThanOrEqualToZero],
    layout: fieldLayout
  }));
};